import { api } from "../../Api/api";

import Swal from "sweetalert2";
import { getToken } from "../login";
import {
  DELETE_BG_GALLERY_FAIL,
  DELETE_BG_GALLERY_SUCCESS,
  FETCH_BG_GALLERY_FAIL,
  FETCH_BG_GALLERY_REQUEST,
  FETCH_BG_GALLERY_SUCCESS,
  SHOW_BG_GALLERY_FAIL,
  SHOW_BG_GALLERY_REQUEST,
  SHOW_BG_GALLERY_SUCCESS,
} from "../../ActionType/GallaryType/BgGalleryType";

export const getBgGalleryAction = () => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  // dispatch({
  //   type: FETCH_BG_GALLERY_REQUEST,
  // });
  api
    .get("bgGallery", config)
    .then((res) => {
      // console.log(res.data)
      dispatch({
        type: FETCH_BG_GALLERY_SUCCESS,
        payload: res.data,
        total: res.data.total,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_BG_GALLERY_FAIL,
        payload: [],
        error: "",
      });
    });
};

export const createBgGalleryAction = (image) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  const formData = new FormData();

  formData.append("bg_image", image);

  // console.log(formData);

  api
    .post("bgGallery/create", formData, config)
    .then((res) => {
      
      if (res.status == 200) {
        Swal.fire({
          icon: "success",
          timer: 2000,
          title: "Good Job",
          text: "Information Was Saved",
        });
        window.location.reload()
      }
    })
    .catch((err) => {
      Swal.fire({
        icon: "error",
        timer: 2000,
        title: "Error",
        text: "Please Check Your Request",
      });
      console.log(err);
    });
};

export const deleteBgGalleryAction = (id) => (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  api
    .delete(`bgGallery/delete/${id}`, config)
    .then((res) => {
      if (res.status == 200) {
        dispatch({
          type: DELETE_BG_GALLERY_SUCCESS,
          payload: res.data,
        });
        Swal.fire({
          icon: "success",
          timer: 2000,
          title: "Good Job",
          text: "Information Was Delete",
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: DELETE_BG_GALLERY_FAIL,
        // payload: res.data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,
        title: "Error",
        text: "Please Check Your Request",
      });
      console.log(err);
    });
};

export const showBgGalleryAction = (id) => (dispatch) => {
  //   console.log(formData)
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: SHOW_BG_GALLERY_REQUEST,
    // payload: res.data,
  });
  api
    .get(`bgGallery/show/${id}`, config)
    .then((res) => {
      if (res.status == 200) {
        dispatch({
          type: SHOW_BG_GALLERY_SUCCESS,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: SHOW_BG_GALLERY_FAIL,
        // payload: res.data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,
        title: "Error",
        text: "Please Check Your Request",
      });
      // console.log(err);
    });
};

export const updateBgGalleryAction = (id, image) => (dispatch) => {
  const formData = new FormData();

  formData.append("bg_image", image);
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  api
    .post(`bgGallery/update/${id}`, formData, config)
    .then((res) => {
      //  console.log(res)
      if (res.status == 200) {
        // console.log(res)
        Swal.fire({
          icon: "success",
          timer: 2000,
          title: "Good Job",
          text: "Information Was Saved",
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: SHOW_BG_GALLERY_FAIL,
        // payload: res.data,
      });
      Swal.fire({
        icon: "error",
        timer: 2000,
        title: "Error",
        text: "Please Check Your Request",
      });
      //   console.log(err);
    });
};
